module.exports = __webpack_public_path__ + "img/brand (12).d4ad57e8.svg";